import { type AppSnapshot, parseAppSnapshots } from "@/features/app-studio/api/appSnapshotsApi";
import { apiFetch } from "@/shared/api/apiFetch";
import { readApiErrorMessage } from "@/shared/api/parseApiErrorMessage";

/**
 * The snapshots available for a published app, newest first — what the view's snapshot picker lists.
 *
 * Metadata only. Selecting one does not fetch its content here: the items stream is re-pointed at the
 * snapshot's own route, which replays the stored document as ordinary SSE frames.
 */
export async function listPublishedAppSnapshots(appId: number): Promise<AppSnapshot[]> {
  const res = await apiFetch(`/v1/published-apps/${appId}/snapshots`, { method: "GET" });
  if (!res.ok) {
    throw new Error(await readApiErrorMessage(res));
  }
  return parseAppSnapshots(await res.json());
}
